/* eslint-disable */
import React, { useState } from 'react';
import { 
  RiSettingsLine,
  RiShieldKeyholeLine, 
  RiNotificationLine,
  RiDatabaseLine,
  RiGlobalLine, 
  RiMailLine
} from 'react-icons/ri';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({
    general: {
      siteName: 'Brilliant Pharmaceutical',
      siteDescription: 'Quality healthcare solutions',
      siteUrl: 'https://brilliantpharmaceutical.com',
      adminEmail: 'ceo@brilliantpharmaceutical.com',
      timezone: 'Africa/Juba'
    },
    email: {
      smtpHost: 'smtp.gmail.com',
      smtpPort: '587',
      smtpUsername: '',
      smtpPassword: '',
      fromName: 'Brilliant Pharmaceutical',
      fromEmail: 'noreply@brilliant.com'
    },
    security: {
      requireAdminApproval: true,
      maxLoginAttempts: 5,
      sessionTimeout: 30,
      enable2FA: false
    },
    notifications: {
      emailAlerts: true,
      newUserNotification: true,
      orderNotification: true,
      appointmentNotification: true
    }
  });

  const tabs = [
    { id: 'general', label: 'General', icon: <RiSettingsLine /> },
    { id: 'email', label: 'Email Settings', icon: <RiMailLine /> },
    { id: 'security', label: 'Security', icon: <RiShieldKeyholeLine /> },
    { id: 'notifications', label: 'Notifications', icon: <RiNotificationLine /> },
    { id: 'backup', label: 'Backup & Restore', icon: <RiDatabaseLine /> }
  ];

  const handleSave = () => {
    // Implement save logic
    alert('Settings saved successfully!');
  };

  const handleExport = () => {
    const dataStr = JSON.stringify(settings, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    const exportFileDefaultName = 'brilliant-settings.json';
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const importedSettings = JSON.parse(e.target.result);
          setSettings(importedSettings);
          alert('Settings imported successfully!');
        } catch (error) {
          alert('Error importing settings: Invalid file format');
        }
      };
      reader.readAsText(file);
    }
  };

  const renderTabContent = () => {
    const currentSettings = settings[activeTab];

    switch (activeTab) {
      case 'general':
        return (
          <div className="settings-form">
            <div className="form-group">
              <label>Site Name</label>
              <input
                type="text"
                value={currentSettings.siteName}
                onChange={(e) => setSettings({
                  ...settings,
                  general: {...currentSettings, siteName: e.target.value}
                })}
              />
            </div>

            <div className="form-group">
              <label>Site Description</label>
              <textarea
                value={currentSettings.siteDescription}
                onChange={(e) => setSettings({
                  ...settings,
                  general: {...currentSettings, siteDescription: e.target.value}
                })}
                rows="3"
              />
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Site URL</label>
                <input
                  type="url"
                  value={currentSettings.siteUrl}
                  onChange={(e) => setSettings({
                    ...settings,
                    general: {...currentSettings, siteUrl: e.target.value}
                  })}
                />
              </div>

              <div className="form-group">
                <label>Admin Email</label>
                <input
                  type="email"
                  value={currentSettings.adminEmail}
                  onChange={(e) => setSettings({
                    ...settings,
                    general: {...currentSettings, adminEmail: e.target.value}
                  })}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Timezone</label>
              <select
                value={currentSettings.timezone}
                onChange={(e) => setSettings({
                  ...settings,
                  general: {...currentSettings, timezone: e.target.value}
                })}
              >
                <option value="Africa/Juba">Africa/Juba (UTC+2)</option>
                <option value="UTC">UTC</option>
                <option value="America/New_York">America/New_York</option>
                <option value="Europe/London">Europe/London</option>
                <option value="Asia/Dubai">Asia/Dubai</option>
              </select>
            </div>
          </div>
        );

      case 'email':
        return (
          <div className="settings-form">
            <div className="form-grid">
              <div className="form-group">
                <label>SMTP Host</label>
                <input
                  type="text"
                  value={currentSettings.smtpHost}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, smtpHost: e.target.value}
                  })}
                  placeholder="smtp.gmail.com"
                />
              </div>

              <div className="form-group">
                <label>SMTP Port</label>
                <input
                  type="number"
                  value={currentSettings.smtpPort}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, smtpPort: e.target.value}
                  })}
                  placeholder="587"
                />
              </div>
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>SMTP Username</label>
                <input
                  type="text"
                  value={currentSettings.smtpUsername}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, smtpUsername: e.target.value}
                  })}
                />
              </div>

              <div className="form-group">
                <label>SMTP Password</label>
                <input
                  type="password"
                  value={currentSettings.smtpPassword}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, smtpPassword: e.target.value}
                  })}
                />
              </div>
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>From Name</label>
                <input
                  type="text"
                  value={currentSettings.fromName}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, fromName: e.target.value}
                  })}
                />
              </div>

              <div className="form-group">
                <label>From Email</label>
                <input
                  type="email"
                  value={currentSettings.fromEmail}
                  onChange={(e) => setSettings({
                    ...settings,
                    email: {...currentSettings, fromEmail: e.target.value}
                  })}
                />
              </div>
            </div>

            <div className="test-email">
              <h4>Test Email Configuration</h4>
              <div className="form-group">
                <label>Test Email Address</label>
                <input type="email" placeholder="Enter email to test" />
              </div>
              <button className="btn btn-secondary">Send Test Email</button>
            </div>
          </div>
        );

      case 'security':
        return (
          <div className="settings-form">
            <div className="security-options">
              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.requireAdminApproval}
                    onChange={(e) => setSettings({
                      ...settings,
                      security: {...currentSettings, requireAdminApproval: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>Require Admin Approval for New Users</h4>
                  <p>New user registrations require admin approval</p>
                </div>
              </div>

              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.enable2FA}
                    onChange={(e) => setSettings({
                      ...settings,
                      security: {...currentSettings, enable2FA: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>Enable Two-Factor Authentication</h4>
                  <p>Add an extra layer of security to admin accounts</p>
                </div>
              </div>

              <div className="form-group">
                <label>Maximum Login Attempts</label>
                <input
                  type="number"
                  value={currentSettings.maxLoginAttempts}
                  onChange={(e) => setSettings({
                    ...settings,
                    security: {...currentSettings, maxLoginAttempts: e.target.value}
                  })}
                  min="1"
                  max="10"
                />
                <p className="help-text">Number of failed attempts before account lockout</p>
              </div>

              <div className="form-group">
                <label>Session Timeout (minutes)</label>
                <input
                  type="number"
                  value={currentSettings.sessionTimeout}
                  onChange={(e) => setSettings({
                    ...settings,
                    security: {...currentSettings, sessionTimeout: e.target.value}
                  })}
                  min="5"
                  max="120"
                />
                <p className="help-text">Time before automatic logout due to inactivity</p>
              </div>
            </div>
          </div>
        );

      case 'backup':
        return (
          <div className="settings-form">
            <div className="backup-options">
              <div className="backup-card">
                <h4>Export Settings</h4>
                <p>Download all current settings as a JSON file</p>
                <button className="btn btn-primary" onClick={handleExport}>
                  <RiDatabaseLine /> Export Settings
                </button>
              </div>

              <div className="backup-card">
                <h4>Import Settings</h4>
                <p>Restore settings from a previously exported JSON file</p>
                <div className="import-container">
                  <input
                    type="file"
                    id="importFile"
                    accept=".json"
                    onChange={handleImport}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="importFile" className="btn btn-secondary">
                    Choose File
                  </label>
                  <span className="file-info">No file chosen</span>
                </div>
              </div>

              <div className="backup-card">
                <h4>Database Backup</h4>
                <p>Create a complete backup of your database</p>
                <button className="btn btn-primary" disabled>
                  <RiDatabaseLine /> Backup Database (Coming Soon)
                </button>
              </div>

              <div className="backup-card">
                <h4>Restore Database</h4>
                <p>Restore from a previous database backup</p>
                <button className="btn btn-secondary" disabled>
                  Restore Database (Coming Soon)
                </button>
              </div>
            </div>
          </div>
        );

      case 'notifications':
        return (
          <div className="settings-form">
            <div className="notification-options">
              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.emailAlerts}
                    onChange={(e) => setSettings({
                      ...settings,
                      notifications: {...currentSettings, emailAlerts: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>Email Alerts</h4>
                  <p>Receive email notifications for important events</p>
                </div>
              </div>

              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.newUserNotification}
                    onChange={(e) => setSettings({
                      ...settings,
                      notifications: {...currentSettings, newUserNotification: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>New User Notification</h4>
                  <p>Get notified when new users register</p>
                </div>
              </div>

              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.orderNotification}
                    onChange={(e) => setSettings({
                      ...settings,
                      notifications: {...currentSettings, orderNotification: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>Order Notifications</h4>
                  <p>Receive notifications for new orders</p>
                </div>
              </div>

              <div className="option-item">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentSettings.appointmentNotification}
                    onChange={(e) => setSettings({
                      ...settings,
                      notifications: {...currentSettings, appointmentNotification: e.target.checked}
                    })}
                  />
                  <span className="slider"></span>
                </label>
                <div className="option-info">
                  <h4>Appointment Notifications</h4>
                  <p>Get notified for new appointment bookings</p>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="settings-page">
      <div className="page-header">
        <h2>System Settings</h2>
        <button className="btn btn-primary" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      <div className="settings-container">
        <div className="settings-tabs">
          <div className="tab-buttons">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="settings-content">
          {renderTabContent()}
        </div>
      </div>

      <div className="settings-info">
        <h3>Settings Information</h3>
        <p>
          Changes made here affect the entire system. Make sure to test any email configuration 
          changes and keep regular backups of your settings.
        </p>
        <div className="info-grid">
          <div className="info-item">
            <RiGlobalLine />
            <h4>Global Changes</h4>
            <p>Settings apply to all users immediately</p>
          </div>
          <div className="info-item">
            <RiShieldKeyholeLine />
            <h4>Security First</h4>
            <p>Keep security settings up to date</p>
          </div>
          <div className="info-item">
            <RiDatabaseLine />
            <h4>Regular Backups</h4>
            <p>Always backup before major changes</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;